(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7748],{

/***/ 67748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./lib/numberWithSpaces.js
var numberWithSpaces = __webpack_require__(85364);
// EXTERNAL MODULE: ./lib/config.js
var config = __webpack_require__(6668);
// EXTERNAL MODULE: ./hooks/use-local-storage.js
var use_local_storage = __webpack_require__(34670);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./contexts/NotificationContext.js
var NotificationContext = __webpack_require__(64318);
// EXTERNAL MODULE: ./seo/dataLayer/DataLayer.js + 4 modules
var DataLayer = __webpack_require__(64907);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./containers/product/Product.module.scss
var Product_module = __webpack_require__(26574);
var Product_module_default = /*#__PURE__*/__webpack_require__.n(Product_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/product/Product.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var EXCLUDED_INFO_ATTR_SLUGS = ['strana-dizayna', 'strana-proizvoditel'];
var ProductShop = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5243).then(__webpack_require__.bind(__webpack_require__, 65243));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(65243)];
    }
  }
});
var ProductConfig = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3082).then(__webpack_require__.bind(__webpack_require__, 33082));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33082)];
    }
  }
});
var Accordion = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6962).then(__webpack_require__.bind(__webpack_require__, 6962));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6962)];
    }
  }
});

var BrandLink = function BrandLink(_ref) {
  var brand = _ref.brand,
      link = _ref.link;
  var words = brand.split(' ');
  var lastWord = words[words.length - 1];
  var otherWords = words.slice(0, -1).join(' ');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* RoutedLink */.S4, {
    to: "/".concat(link),
    children: [otherWords, ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (Product_module_default()).withArrow,
      children: [lastWord, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
        name: "arrow-up"
      })]
    })]
  });
};

var Product = function Product(_ref2) {
  var _images_info$title;

  var data = _ref2.data,
      productInfo = _ref2.productInfo,
      dlItemListId = _ref2.dlItemListId,
      dlItemListName = _ref2.dlItemListName;
  var _data$attributes = data.attributes,
      attributes = _data$attributes === void 0 ? [] : _data$attributes,
      brand = data.brand,
      brand_url = data.brand_url,
      breadcrumbs = data.breadcrumbs,
      name = data.name,
      price = data.price,
      old_price = data.old_price,
      price_diff_percent = data.price_diff_percent,
      quantity = data.quantity,
      gallery = data.gallery,
      gallery_thumbs = data.gallery_thumbs,
      gallery_zoom = data.gallery_zoom,
      images_info = data.images_info,
      features = data.features,
      shops = data.shops,
      sku = data.sku,
      _data$description = data.description,
      descriptionRaw = _data$description === void 0 ? '' : _data$description,
      importer = data.importer,
      _data$labels = data.labels,
      labels = _data$labels === void 0 ? {} : _data$labels,
      _data$seo = data.seo,
      seo = _data$seo === void 0 ? {} : _data$seo,
      switchable_attributes = data.switchable_attributes,
      clickOpenShops = data.clickOpenShops,
      _data$show_shops = data.show_shops,
      show_shops = _data$show_shops === void 0 ? true : _data$show_shops,
      _data$no_delivery_to_ = data.no_delivery_to_russia,
      no_delivery_to_russia = _data$no_delivery_to_ === void 0 ? false : _data$no_delivery_to_,
      loadingShops = data.loadingShops,
      model = data.model,
      _data$sex = data.sex,
      sex = _data$sex === void 0 ? null : _data$sex;
  var modelId = model.id,
      modelSlug = model.slug;

  var _useLocalStorage = (0,use_local_storage/* default */.Z)('currency', 'BY'),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      currency = _useLocalStorage2[0],
      _setCurrency = _useLocalStorage2[1];

  var inStock = quantity !== 0;

  var _useState = (0,react.useState)(price),
      actualPrice = _useState[0],
      setActualPrice = _useState[1];

  var _useState2 = (0,react.useState)(null),
      activeImageName = _useState2[0],
      setActiveImageName = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      colorState = _useState3[0],
      setColorState = _useState3[1];

  var notification = (0,NotificationContext/* useNotification */.l)();
  var description = (0,react.useMemo)(function () {
    return descriptionRaw && descriptionRaw !== null && descriptionRaw !== void 0 && descriptionRaw.replaceAll ? descriptionRaw.replaceAll('\r', '\n\r') : descriptionRaw;
  }, [descriptionRaw]);
  (0,react.useEffect)(function () {
    setActualPrice(price);
  }, [price, modelSlug]);
  var priceBYN = (0,react.useMemo)(function () {
    if (currency == 'RU') {
      var hasDiscount = Number(old_price) > Number(actualPrice);
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Product_module_default()).bynPriceBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((Product_module_default()).bynPrice, hasDiscount && (Product_module_default()).bynPriceOld),
          children: [(0,numberWithSpaces/* default */.Z)(hasDiscount ? old_price : actualPrice), " BYN"]
        }), hasDiscount && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (0,clsx_m/* default */.Z)((Product_module_default()).bynPrice, (Product_module_default()).bynPriceSale),
          children: [(0,numberWithSpaces/* default */.Z)(actualPrice), " BYN"]
        })]
      });
    }

    return null;
  }, [currency, actualPrice, old_price]);
  var infoAttributes = (0,react.useMemo)(function () {
    return attributes.filter(function (attr) {
      return attr.type === 'info' && attr.value !== '' && !EXCLUDED_INFO_ATTR_SLUGS.includes(attr.slug);
    });
  }, [attributes]);
  var hasImporterBlock = (importer === null || importer === void 0 ? void 0 : importer.name) || (importer === null || importer === void 0 ? void 0 : importer.address) || (importer === null || importer === void 0 ? void 0 : importer.manufacturer_name) || (importer === null || importer === void 0 ? void 0 : importer.manufacturer_address) || (importer === null || importer === void 0 ? void 0 : importer.country_of_design) || (importer === null || importer === void 0 ? void 0 : importer.country_of_origin);
  var switchAttributes = (0,react.useMemo)(function () {
    return attributes.filter(function (attr) {
      return attr.type === 'switch';
    });
  }, [attributes]);

  var _useState4 = (0,react.useState)(modelSlug),
      currentSlug = _useState4[0],
      setCurrentSlug = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      open = _useState5[0],
      setOpen = _useState5[1];

  var handleSetCurrentSlug = (0,react.useCallback)(function (newSlug) {
    setCurrentSlug(newSlug);
  }, []);
  var alt = (0,react.useMemo)(function () {
    return "".concat(sex ? "".concat(sex, " ") : '').concat(brand, " ").concat(name, " (\u0446\u0432\u0435\u0442 ").concat(activeImageName ? activeImageName === null || activeImageName === void 0 ? void 0 : activeImageName.toLowerCase() : '', "), \u0430\u0440\u0442\u0438\u043A\u0443\u043B ").concat(sku);
  }, [brand, sku, name, switchable_attributes, activeImageName]);

  var handleClickOpenShops = function handleClickOpenShops() {
    var _productInfo$listId, _productInfo$listName;

    setOpen(true);
    clickOpenShops();
    DataLayer/* default.viewStoreAvailability */.Z.viewStoreAvailability({
      item_list_id: (_productInfo$listId = productInfo === null || productInfo === void 0 ? void 0 : productInfo.listId) !== null && _productInfo$listId !== void 0 ? _productInfo$listId : dlItemListId,
      item_list_name: (_productInfo$listName = productInfo === null || productInfo === void 0 ? void 0 : productInfo.listName) !== null && _productInfo$listName !== void 0 ? _productInfo$listName : dlItemListName,
      price: data.price,
      items: [_objectSpread({}, data)]
    });
  };

  (0,react.useEffect)(function () {
    setOpen(false);
    setCurrentSlug(modelSlug);
  }, [modelSlug]);
  var handleSetActualPrice = (0,react.useCallback)(function (newPrice) {
    setActualPrice(newPrice !== null && newPrice !== void 0 ? newPrice : price);
  }, [price]);
  var handleColorState = (0,react.useCallback)(function (value) {
    if (colorState !== value) {
      setColorState(value);
    }
  }, [colorState]);

  var onLoadingError = function onLoadingError(event) {
    var _event$target;

    (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.classList.add((Product_module_default()).loadingError);
  };

  var copyText = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(sku) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.writeText(sku);

            case 2:
              notification.add({
                id: 'copy-sku',
                style: 'warning',
                content: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D"
                }),
                duration: 2000,
                closable: true
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function copyText(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Product_module_default()).product,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Product_module_default()).breadCrumbs,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
        breadcrumbs: breadcrumbs
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((Product_module_default()).gallery, 'productGallery'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductGallery */.Li, {
        images: gallery,
        thumbs: gallery_thumbs,
        zoom: gallery_zoom,
        alt: alt,
        title: (_images_info$title = images_info === null || images_info === void 0 ? void 0 : images_info.title) !== null && _images_info$title !== void 0 ? _images_info$title : null,
        onLoadingError: onLoadingError
      }, modelId)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Product_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
          className: (Product_module_default()).title,
          children: [brand && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Product_module_default()).brand,
            children: brand_url ? /*#__PURE__*/(0,jsx_runtime.jsx)(BrandLink, {
              brand: brand,
              link: brand_url
            }) : brand
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Product_module_default()).desc,
            children: seo && seo.h1 ? (0,utils/* getCorrectName */.tx)(seo.h1) : name
          }), sku && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (0,clsx_m/* default */.Z)((Product_module_default()).attributes, (Product_module_default()).sku),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (Product_module_default()).name,
              children: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u0442\u043E\u0432\u0430\u0440\u0430:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (Product_module_default()).value,
              onClick: function onClick() {
                copyText(sku);
              },
              title: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0440\u0442\u0438\u043A\u0443\u043B",
              children: sku
            })]
          })]
        }), features && features.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (Product_module_default()).features,
          children: features // .sort((a, b) => (Number(a.priority) > Number(b.priority) ? -1 : 1))
          .map(function (_ref4, ind) {
            var id = _ref4.id,
                label = _ref4.label,
                type = _ref4.type,
                text = _ref4.text,
                is_product_card = _ref4.is_product_card;
            return is_product_card ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: (Product_module_default()).feature,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductFeature */["if"], {
                title: label,
                styledType: type,
                text: text
              })
            }, id || ind) : null;
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Product_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductConfig, {
          modelId: modelId,
          switchAttributes: switchAttributes,
          slug: modelSlug,
          actualPrice: price,
          currentSlug: currentSlug,
          setCurrentSlug: handleSetCurrentSlug,
          inStock: inStock,
          data: data,
          productInfo: productInfo,
          isProductPage: true,
          setActualPrice: handleSetActualPrice,
          setColorState: handleColorState,
          setActiveImageName: setActiveImageName,
          onLoadingError: onLoadingError,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [inStock && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((0,defineProperty/* default */.Z)({}, (Product_module_default()).singleCell, !(Number(old_price) > Number(actualPrice) && !!price_diff_percent)), (Product_module_default()).priceWrap, currency == 'BY' && (Product_module_default()).priceWrapBY),
                children: [Number(old_price) > Number(actualPrice) && !!price_diff_percent && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Product_module_default()).discountPercent,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductFeature */["if"], {
                    title: "".concat(price_diff_percent, "%"),
                    styledType: "sale"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Product_module_default()).prices,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Price */.tA, {
                    price: actualPrice,
                    oldPrice: old_price,
                    isProductCard: true,
                    isProduct: true
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: priceBYN
              })]
            }), (labels === null || labels === void 0 ? void 0 : labels.counter_message) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Product_module_default()).buy,
              children: labels.counter_message
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (Product_module_default()).marketplaceFeatures,
          children: config/* marketplaceFeatures.map */.a9.map(function (feature) {
            var icon = feature.icon,
                text = feature.text;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: (Product_module_default()).item,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
                name: icon
              }), icon === 'delivery' && no_delivery_to_russia ? 'Быстрая доставка по Беларуси' : text]
            }, text);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Product_module_default()).accordions,
          children: [(description || sku || infoAttributes.length > 0) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Accordion, {
            headChild: /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (Product_module_default()).accordionHeader,
              children: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
            }),
            mod: "product",
            initialOpen: true,
            children: [description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (Product_module_default()).description,
              children: description
            }), infoAttributes.map(function (_ref5) {
              var infoName = _ref5.name,
                  value = _ref5.value;
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (0,clsx_m/* default */.Z)((Product_module_default()).attributes, (Product_module_default()).attrDesc),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (Product_module_default()).name,
                  children: [infoName, ":"]
                }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (Product_module_default()).value,
                  children: value
                })]
              }, infoName);
            })]
          }), hasImporterBlock && /*#__PURE__*/(0,jsx_runtime.jsxs)(Accordion, {
            headChild: /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (Product_module_default()).accordionHeader,
              children: "\u0418\u043C\u043F\u043E\u0440\u0442\u0435\u0440"
            }),
            mod: "product",
            children: [(importer === null || importer === void 0 ? void 0 : importer.name) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u0418\u043C\u043F\u043E\u0440\u0442\u0435\u0440: ", importer.name]
            }), (importer === null || importer === void 0 ? void 0 : importer.address) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u0410\u0434\u0440\u0435\u0441: ", importer.address]
            }), (importer === null || importer === void 0 ? void 0 : importer.manufacturer_name) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (Product_module_default()).importerLine,
              children: ["\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C: ", importer.manufacturer_name]
            }), importer.manufacturer_address && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u0410\u0434\u0440\u0435\u0441: ", importer.country_of_design ? "".concat(importer.country_of_design, ", ") : '', importer.manufacturer_address]
            }), (importer === null || importer === void 0 ? void 0 : importer.country_of_origin) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\u0421\u0442\u0440\u0430\u043D\u0430 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0442\u043E\u0432\u0430\u0440\u0430: ", importer.country_of_origin]
            })]
          }), show_shops && /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion, {
            headChild: /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (Product_module_default()).accordionHeader,
              children: "\u041D\u0430\u043B\u0438\u0447\u0438\u0435 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445"
            }),
            mod: "product",
            clickOpen: handleClickOpenShops,
            unmountOnClose: true,
            initialOpen: open,
            children: loadingShops ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 23,
                width: "90%",
                style: {
                  marginBottom: '16px'
                }
              }, 'skeleton1'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 20,
                width: "40%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton2'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 20,
                width: "80%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton3'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 20,
                width: "60%",
                style: {
                  marginBottom: '16px'
                }
              }, 'skeleton4'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 20,
                width: "40%",
                style: {
                  marginBottom: '8px'
                }
              }, 'skeleton5'), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                count: 1,
                height: 23,
                width: "90%",
                style: {
                  marginBottom: '16px'
                }
              }, 'skeleton6')]
            }) : shops && shops.map(function (shop) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductShop, _objectSpread(_objectSpread({}, shop), {}, {
                activeVariantId: modelSlug,
                colorState: colorState
              }), shop.name);
            })
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var product_Product = (Product);
;// CONCATENATED MODULE: ./containers/product/index.js

/* harmony default export */ var product = (product_Product);

/***/ }),

/***/ 26574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__JvICU","loadingError":"Product_loadingError__PulvA","breadCrumbs":"Product_breadCrumbs__ZZwTu","gallery":"Product_gallery__XPTNZ","header":"Product_header__FpVPn","title":"Product_title__nS7IG","desc":"Product_desc__7j3VE","brand":"Product_brand__g__YI","empty":"Product_empty__fQAct","features":"Product_features__YjQQH","feature":"Product_feature__i9Kky","price":"Product_price__gEHtD","buy":"Product_buy__nLTle","priceWrap":"Product_priceWrap__Alcx6","singleCell":"Product_singleCell__SF9gW","discountPercent":"Product_discountPercent__2TMBk","priceWrapBY":"Product_priceWrapBY__Q7j9l","content":"Product_content__1dYvn","marketplaceFeatures":"Product_marketplaceFeatures__I0eXw","item":"Product_item__vJAKA","accordions":"Product_accordions__cC_y0","accordionHeader":"Product_accordionHeader__Wkq9B","description":"Product_description__0cDEF","attributes":"Product_attributes__oWs7p","name":"Product_name__Qnu7D","value":"Product_value__NzDOK","sku":"Product_sku__nJBtw","attrDesc":"Product_attrDesc__pOVkd","withArrow":"Product_withArrow__mTtO3","bynPriceBlock":"Product_bynPriceBlock__qgVBK","bynPrice":"Product_bynPrice__hoLJZ","bynPriceOld":"Product_bynPriceOld__lHabq","bynPriceSale":"Product_bynPriceSale__fyfHv","load":"Product_load__w8G5y"};

/***/ })

}]);